import { render, staticRenderFns } from "./PainelComunicacao.vue?vue&type=template&id=352c88ea"
import script from "./PainelComunicacao.vue?vue&type=script&lang=js"
export * from "./PainelComunicacao.vue?vue&type=script&lang=js"
import style0 from "./PainelComunicacao.vue?vue&type=style&index=0&id=352c88ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports